import { Lookup } from '../lookups/Lookup';

export class CoveredArea {
  country!: Lookup;
  cities!: Lookup[];
  selected!: Lookup[];
}
